/**
 * Return the original timestamp exposed by Outlook for a read item.
 * `dateTimeCreated` is the Mailbox API field; the Graph-style field names are
 * accepted as well so mocks and future Outlook hosts can pass them through.
 */
export function getOriginalMailDate(item: any, fallback: Date = new Date()): Date {
  const candidates = [
    item?.receivedDateTime,
    item?.sentDateTime,
    item?.dateTimeCreated
  ];

  for (const candidate of candidates) {
    if (candidate === undefined || candidate === null || candidate === "") continue;
    const parsed = candidate instanceof Date ? candidate : new Date(candidate);
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }

  return fallback;
}

/**
 * Format a timestamp for Odoo Datetime fields in naive UTC form.
 *
 * Older Outlook modules pass this value directly to the ORM and therefore
 * require `YYYY-MM-DD HH:mm:ss`. Newer modules normalize the same value with
 * their ISO parser, so this representation is compatible with both versions.
 */
export function formatOdooDateTime(value: Date): string {
  return value.toISOString().slice(0, 19).replace("T", " ");
}
